import Glide from "@glidejs/glide";
import { forAllCallback } from "../../../scripts/utils/helpers";
export default (function () {
    forAllCallback(".content-block.content-block--slider", function (el) {
        var glideEl = el.querySelector(".glide");
        if (glideEl) {
            var glide = new Glide(glideEl, {
                type: "carousel",
                rewind: false,
                animationDuration: 300,
            });
            glide.mount();
        }
    });
});
